export default {
  install(Vue, options) {
    Vue.prototype.$display = function(path) {
      var array = window.localStorage.getItem("buttonsList").split(",");
      return array.indexOf(path) > -1;
    }
  }
}
